'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002426 from "./presto.-Agent-View$$anon$26.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
import * as $j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024 from "./presto.types$proto$-Unsigned-File-Base64$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$25() {
  this.ay1 = null;
  this.axT = null;
  this.axU = false;
  this.ay2 = null;
  this.ay3 = false;
  this.ay6 = null;
  this.axZ = null;
  this.ay0 = false;
  this.axV = null;
  this.axW = false;
  this.axX = null;
  this.axY = false;
  this.ay4 = false;
  this.ay5 = false;
  this.ay1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ay6 = "UnsignedFileBase64";
}
export { $c_Lpresto_AgentView$$anon$25 as $c_Lpresto_AgentView$$anon$25 };
$p = $c_Lpresto_AgentView$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$25;
/** @constructor */
function $h_Lpresto_AgentView$$anon$25() {
}
export { $h_Lpresto_AgentView$$anon$25 as $h_Lpresto_AgentView$$anon$25 };
$h_Lpresto_AgentView$$anon$25.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.ay1;
});
$p.L = (function() {
  if ((!this.axU)) {
    this.axT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axU = true;
  }
  return this.axT;
});
$p.O = (function() {
  if ((!this.ay3)) {
    this.ay2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ay3 = true;
  }
  return this.ay2;
});
$p.E = (function() {
  return this.ay6;
});
$p.t = (function() {
  if ((!this.ay0)) {
    this.axZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ay0 = true;
  }
  return this.axZ;
});
$p.M = (function() {
  if ((!this.axW)) {
    this.axV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a2A(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().r2(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axW = true;
  }
  return this.axV;
});
$p.Q = (function() {
  if ((!this.axY)) {
    this.axX = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002426.$c_Lpresto_AgentView$$anon$26();
    this.axY = true;
  }
  return this.axX;
});
$p.w = (function() {
  if ((!this.ay5)) {
    this.ay4 = false;
    this.ay5 = true;
  }
  return this.ay4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee176) => ((p) => \u03b4scrutinee176.cH1(p)))($j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024.$m_Lpresto_types$proto$UnsignedFileBase64$())));
});
var $d_Lpresto_AgentView$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$25, "presto.AgentView$$anon$25", ({
  DO: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$25 as $d_Lpresto_AgentView$$anon$25 };
//# sourceMappingURL=presto.-Agent-View$$anon$25.js.map
